import React, { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { useNavigate, useLocation } from "react-router-dom";
import bgImage from "./assets/UP.png";                // adjust path if needed
import msLogo from "./assets/microsoft-logo.svg";     // adjust path if needed
import { loginRequest } from "../authConfig";
import "../styles/LoginPage.css"; // ensure global overflow hidden

const LoginPage = () => {
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const location = useLocation();
  const [animateLogin, setAnimateLogin] = useState(false);

  // Redirect to /home once signed in
  useEffect(() => {
    if (accounts.length > 0) {
      const dest = location.state?.from?.pathname || "/home";
      navigate(dest, { replace: true });
    }
  }, [accounts, navigate, location]);
 

  // Trigger the slide-in animation
  useEffect(() => {
    const timer = setTimeout(() => setAnimateLogin(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const handleLogin = () => instance.loginRedirect(loginRequest);

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100%",          // use 100% to avoid vw overflow
        overflow: "hidden",     // hide any overflow scrollbars
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        fontFamily: "'Poppins', sans-serif",
      }}
    >
      {/* Left text panel */}
      <Box
        sx={{
          width: { xs: "100%", md: "70%" },
          px: { xs: 3, md: 6 },
          py: { xs: 4, md: 6 },
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          color: "#fff",
        }}
      >
        <Typography
          variant="h5"
          sx={{ fontWeight: 400, mb: 1, fontSize: { xs: "1.2rem", md: "1.5rem" } }}
        >
          Welcome To
        </Typography>
        <Typography
          variant="h3"
          sx={{ fontWeight: 700, mb: 2, lineHeight: 1.2, fontSize: { xs: "1.8rem", md: "2.5rem" } }}
        >
          Bosch Smart Pulse Reporting System
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 500, fontSize: { xs: "1rem", md: "1.2rem" }, mt: 1 }}
        >
          Powered By Bosch: Smart Analytics For Smart Power Delivery
        </Typography>
      </Box>

      {/* Right login card */}
      <Box
        sx={{
          width: { xs: "100%", md: "30%" },
          minWidth: "300px",
          bgcolor: "rgba(122,169,172,0.4)",
          backdropFilter: "blur(14px)",
          color: "#fff",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          px: 4,
          py: 6,
          transform: animateLogin
            ? "translateX(0)"
            : { xs: "translateY(100%)", md: "translateX(100%)" },
          opacity: animateLogin ? 1 : 0,
          transition: "all 0.8s ease-in-out",
        }}
      >
        <img
          src={msLogo}
          alt="Microsoft Logo"
          style={{ width: 60, height: 60, marginBottom: 16 }}
        />

        <Typography
          variant="h6"
          sx={{ fontWeight: 600, textAlign: "center", mb: 3, fontSize: { xs: "1rem", md: "1.2rem" } }}
        >
          Sign in With Your Account
        </Typography>

        <Button
          variant="contained"
          color="primary"
          onClick={handleLogin}
          sx={{
            fontWeight: "bold",
            px: 4,
            py: 1.5,
            borderRadius: "8px",
            mb: 2,
            fontSize: "14px",
            textTransform: "uppercase",
            boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
          }}
        >
          Login with Microsoft
        </Button>
      </Box>
    </Box>
  );
};

export default LoginPage;